/**
 * polishCalendar.js
 * Path: frontend/src/utils/polishCalendar.js
 * Description: Oblicza polskie święta ustawowo wolne od pracy dla widoku harmonogramu.
 * Related: components/MonthCalendar.jsx
 */

// ============================================================
// UTC DATE HELPERS
// ============================================================

function toIsoDateUtc(dateObj) {
  return dateObj.toISOString().slice(0, 10);
}

function addDaysUtc(dateObj, days) {
  const next = new Date(dateObj);
  next.setUTCDate(next.getUTCDate() + days);
  return next;
}

// ============================================================
// MOVABLE HOLIDAYS
// ============================================================

function calculateEasterSundayUtc(year) {
  const a = year % 19;
  const b = Math.floor(year / 100);
  const c = year % 100;
  const d = Math.floor(b / 4);
  const e = b % 4;
  const f = Math.floor((b + 8) / 25);
  const g = Math.floor((b - f + 1) / 3);
  const h = (19 * a + b - d - g + 15) % 30;
  const i = Math.floor(c / 4);
  const k = c % 4;
  const l = (32 + 2 * e + 2 * i - h - k) % 7;
  const m = Math.floor((a + 11 * h + 22 * l) / 451);
  const month = Math.floor((h + l - 7 * m + 114) / 31);
  const day = ((h + l - 7 * m + 114) % 31) + 1;
  return new Date(Date.UTC(year, month - 1, day));
}

function pushHoliday(map, isoDate, name) {
  const existing = map.get(isoDate) || [];
  map.set(isoDate, [...existing, name]);
}

// ============================================================
// PUBLIC API
// ============================================================

export function getPolishPublicHolidays(year) {
  const holidays = new Map();
  const fixed = [
    { md: "01-01", name: "Nowy Rok" },
    { md: "01-06", name: "Trzech Króli" },
    { md: "05-01", name: "Święto Pracy" },
    { md: "05-03", name: "Święto Konstytucji 3 Maja" },
    { md: "08-15", name: "Wniebowzięcie NMP / Święto Wojska Polskiego" },
    { md: "11-01", name: "Wszystkich Świętych" },
    { md: "11-11", name: "Narodowe Święto Niepodległości" },
    { md: "12-24", name: "Wigilia Bożego Narodzenia" },
    { md: "12-25", name: "Boże Narodzenie (1 dzień)" },
    { md: "12-26", name: "Boże Narodzenie (2 dzień)" },
  ];

  fixed.forEach((item) => {
    pushHoliday(holidays, `${year}-${item.md}`, item.name);
  });

  const easterSunday = calculateEasterSundayUtc(year);
  pushHoliday(holidays, toIsoDateUtc(easterSunday), "Wielkanoc");
  pushHoliday(holidays, toIsoDateUtc(addDaysUtc(easterSunday, 1)), "Poniedziałek Wielkanocny");
  pushHoliday(holidays, toIsoDateUtc(addDaysUtc(easterSunday, 49)), "Zielone Świątki");
  pushHoliday(holidays, toIsoDateUtc(addDaysUtc(easterSunday, 60)), "Boże Ciało");

  return holidays;
}
